var React = require('react');

var DatePicker = require('./datepicker');
var CheckboxGroup = require('react-checkbox-group');
var FilterSettings = require('./constants');

var GuideFilter = React.createClass({

  getInitialState: function(){
    return {
      startingDate: this.props.startingDate,
      numDays: this.props.numDays,
      pace: this.props.pace,
      filter: this.props.filter
    };
  },
  
  handleChange: function(submitted) {

    if (this.props.isSmallScreen) {
      if (submitted) {
        this.props.onChange(this.state.numDays,
                            this.state.pace,
                            this.state.startingDate,
                            this.state.filter,
                            'list-view');
      } else {
        TweenLite.to(window, 0.6, {scrollTo:{y:0}, ease:Power2.easeOut});    
      }
    } else {
      this.props.onChange(this.state.numDays,
                          this.state.pace,
                          this.state.startingDate,
                          this.state.filter);
    }
  },
  handleDateChange: function(date, event) {
    if (date === '') {
      date = this.refs.startingDate.getDOMNode().value;
    }
    this.setState({startingDate: moment(date)}, function(){
      this.handleChange();
    });
  },

  getDayButtons: function() {
    var buttons = [];
    for(var i=1; i<=5; i++){
      var active = '';
      if (i === this.state.numDays) {
        active = ' active';
      }
      buttons.push(<a key={i} className={"btn btn-sm btn-days"+active} onClick={this.handleDayChange.bind(this, i)}>{i}</a>);
    }
    return <div className="btns-filter">{buttons}</div>;
  },
  handleDayChange: function(day, event) {
    if (day !== this.state.numDays) {
      this.setState({numDays: day}, function(){
        this.handleChange();
      });
    }
  },

  getPaceButtons: function() {
    var buttons = [],
        paceLabels = ['Slow', 'Medium', 'Fast'];
    for(var i=1; i<=3; i++){
      var active = '';
      if (i === this.state.pace) {
        active = ' active';
      }
      buttons.push(<a key={i} className={"btn btn-sm btn-days"+active} onClick={this.handlePaceChange.bind(this, i)}>{paceLabels[i-1]}</a>);
    }
    return <div className="btns-filter">{buttons}</div>;
  },
  handlePaceChange: function(pace, event) {
    if (pace !== this.state.pace) {
      this.setState({pace: pace}, function(){
        this.handleChange();
      });
    }
  },

  getDatePicker: function() {
    var userAgent = window.navigator.userAgent;
    if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i)) {
      var date = moment(this.state.startingDate).format('YYYY-MM-DD');
      return (
        <div className="date-picker">
          <input style={{fontSize: 16, width: '80%'}} type="date" ref="startingDate" onChange={this.handleDateChange.bind(this, '')} value={date} />
        </div>
      );
    }

    //    return <DateTimePicker ref="startingDate" onChange={this.handleDateChange} value={moment(this.state.startingDate).toDate()} time={false} format={"MMM dd, yyyy"} finalView={"month"} />;
    return <DatePicker value={moment(this.state.startingDate).toDate()} format={"mmm dd, yyyy"} onChange={this.handleDateChange} />;
  },
  
  getFilters: function() {
    var filters = this.state.filter || [];
    var choices = FilterSettings.values;
    var checkboxes = [];

    choices.forEach(function(choice, i) {
      var label = FilterSettings.labelMap[choice];
      checkboxes.push(<div className="col-sm-12 col-md-6 col-xs-5 filter-choice" key={i}>
                      <label className="filter-chk">
                      <input type="checkbox" value={choice} className="filter-chk"/>
                      <span className="filter-chk-target"></span>
                      </label>
                      {label}
                      </div>);
    });

    return (
        <CheckboxGroup name="filter" ref="filter" value={filters} onChange={this.handleFilterChange}>
        {checkboxes}
        </CheckboxGroup>
      );
  },

  handleFilterChange: function(event) {
    var choices = _.sortBy(this.refs.filter.getCheckedValues());
    this.setState({filter: choices}, function(){
      this.handleChange();
    });
  },

  componentDidMount: function() {
//    this.numDays = this.props.numDays;
  },
  
  render: function(){
    var showButton = null;
    if (this.props.isSmallScreen) {
      if (this.props.mobileCurrentView !== 'filter-view') {
        return null;
      }
      showButton = <a href='#' onClick={this.handleChange.bind(null, true)}><i className="fa fa-arrow-left"></i> Back</a>;
    }
    
    var daysLabel = (this.props.numDays > 1) ? ' Days' : ' Day';

    return (
      <div className='c_guide-filter'>
        <h2>{showButton}</h2>
        <div id="filter" className="col-xs-12">
          <div className="param col-sm-3 col-xs-12">
	          <label>Days:</label>
            {this.getDayButtons()}
	        </div>
          <div className="param col-sm-3 col-xs-12">
  	        <label>Pace:</label>
            {this.getPaceButtons()}
  	      </div>

          <div className="param col-sm-3 col-xs-12">
            <label>Starting on:</label>
            {this.getDatePicker()}
          </div>

          <div className="param col-sm-3 col-xs-12">
  	        <label>Interests:</label>
            {this.getFilters()}
          </div>
        </div>
      </div>
    );
  }
});

module.exports = GuideFilter;



// WEBPACK FOOTER //
// ./components/filter.js